import Hub from './src/hub';
import logMiddleware from './src/middleware/log';

Hub.logMiddleware =  logMiddleware;

export default Hub;
